import { useState } from 'react';
import { Drawer, Button, Menu } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import styles from '../../styles/headerMobileMenu.module.scss';
import stylesHeader from '../../styles/header.module.scss';
import { Dropdown } from 'antd';
import { useAuth } from '../../context/useAuth';
import ProfileCard from '../cards/ProfileCard';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { findActiveMenu, tabUrl } from '../../router/menu';

const HeaderMobileMenu = ({ menuGroups }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const activeTab = findActiveMenu(location.pathname, location.search)?.tab;

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };

  const handleNavigation = (slug) => {
    navigate(slug);
    closeDrawer();
  };

  return (
    <div className={styles.headerMobileMenu}>
      <Button
        type="text"
        icon={<MenuOutlined />}
        onClick={showDrawer}
        style={{ fontSize: '20px' }}
      />
      <Drawer
        // title="Menu"
        placement="right"
        width="100%"
        onClose={closeDrawer}
        open={visible}
        closeIcon={null}
        mask={true}
      >
        {/* <Menu mode="vertical" items={items} /> */}
        <div className={styles.menu}>
          <div className={styles.menu__content}>
            <div className={styles.menu__header}>
              <img
                className={stylesHeader.header__container__logo}
                src="/logo.svg"
                alt="logo"
                height={42}
                width={42}
              />
              <div className={stylesHeader.header__right}>
                <Dropdown
                  open={isDropdownVisible}
                  onOpenChange={(visible) => setIsDropdownVisible(visible)}
                  trigger={['click']}
                  popupRender={() => (
                    <ProfileCard
                      onOpenModal={() => setIsDropdownVisible(false)}
                    />
                  )}
                  className={stylesHeader.header__right__profileDropdown}
                >
                  <div
                    style={{
                      cursor: 'pointer',
                      padding: user?.profileImage ? '0' : '8px',
                    }}
                    className={stylesHeader.header__imageContainer}
                  >
                    <img
                      src={user?.profileImage || '/assets/icons/user.svg'}
                      alt="user_icon"
                    />
                  </div>
                </Dropdown>
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: user?.profileImage ? '0' : '8px',
                  }}
                  className={stylesHeader.header__imageContainer}
                  onClick={closeDrawer}
                >
                  <div className={stylesHeader.header__closeIcon}>X</div>
                </div>
              </div>
            </div>
            <div className={styles.menu__body}>
              <div className={styles.menu__body__list}>
                {menuGroups.map((group) => (
                  <div className={styles.menu__body__group} key={group.key}>
                    <div className={styles.menu__body__group__label}>
                      {group.label}
                    </div>
                    {group.tabs.map((tab) => (
                      <div
                        className={`${styles.menu__body__list__item} ${activeTab === tab ? styles.menu__body__list__item__active : ''}`}
                        key={tab.key}
                        onClick={() => handleNavigation(tabUrl(tab))}
                      >
                        {tab.label}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

HeaderMobileMenu.propTypes = {
  menuGroups: PropTypes.array.isRequired,
};

export default HeaderMobileMenu;
